import type { ReactNode } from 'react';
import { Navigate, type RouteObject } from 'react-router';
import type { Permission } from '@barbeiropro/contracts';
import { RequirePermission } from '@/app/require-permission';
import { AccountPage } from './account-page';
import { AuditPage } from './audit-page';
import { BranchesPage } from './branches-page';
import { BusinessPage } from './business-page';
import { HoursPage } from './hours-page';
import { IntegrationsPage } from './integrations-page';
import { MembersPage } from './members-page';
import { PolicyPage } from './policy-page';
import { SubscriptionPage } from './subscription-page';
import { SettingsIndex, SettingsLayout } from './settings-layout';

const guard = (p: Permission, el: ReactNode) => <RequirePermission anyOf={[p]}>{el}</RequirePermission>;

export const appRoutes: RouteObject[] = [
  { path: 'conta', element: <AccountPage /> },
  {
    path: 'configuracoes',
    element: <SettingsLayout />,
    children: [
      { index: true, element: <SettingsIndex /> },
      { path: 'barbearia', element: guard('settings.manage', <BusinessPage />) },
      { path: 'unidades', element: guard('settings.manage', <BranchesPage />) },
      { path: 'horarios', element: guard('settings.manage', <HoursPage />) },
      { path: 'regras', element: guard('settings.manage', <PolicyPage />) },
      { path: 'equipe', element: guard('members.manage', <MembersPage />) },
      { path: 'assinatura', element: guard('settings.manage', <SubscriptionPage />) },
      { path: 'integracoes', element: guard('settings.manage', <IntegrationsPage />) },
      { path: 'conta', element: <Navigate to="/app/conta" replace /> },
      { path: 'auditoria', element: guard('audit.read', <AuditPage />) },
      { path: '*', element: <Navigate to="/app/configuracoes" replace /> },
    ],
  },
];
